import axios from "axios";
import { APIENDPOINT } from "../app.config";
import store from "@/store/index";

const getHeaderConfig = function () {
    const token: string = store.getters["authentication/getToken"];
    const headers = {
        Accept: "application/json",
        Authorization: "Bearer " + token
    };
    return headers;
};

export default {
    get(url: string) {
        return axios.get(APIENDPOINT + url, {
            headers: getHeaderConfig()
        });
    },
    post(url: string, data: any) {
        return axios({
            method: "POST",
            url: APIENDPOINT + url,
            headers: getHeaderConfig(),
            data
        });
    },
    put(url: string, data: any) {
        return axios({
            method: "PUT",
            url: APIENDPOINT + url,
            headers: getHeaderConfig(),
            data
        });
    },
    delete(url: string) {
        return axios.delete(APIENDPOINT + url, {
            headers: getHeaderConfig()
        });
    },
    postFormData(url: string, data: any, config: any) {
        const instance = axios.create({
            method: "POST",
            headers: getHeaderConfig()
        });

        return instance.post(APIENDPOINT + url, data, config);
    }
};
